var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"permissions-warning",attrs:{"row":"","align-center":"","justify-start":""}},[_c('v-icon',{staticClass:"pr-2",attrs:{"small":""}},[_vm._v("lock")]),_vm._v(" "),_c('span',[_vm._v("\n    "+_vm._s(_vm.permission ? _vm.permission : _vm.$t("NoPermissionDefaultWarning"))+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b45eafa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Molecules/AppNoPermissionWarning.vue
// module id = null
// module chunks = 